<template>
  <div>
    <v-hover v-slot:default="{ hover }">
      <div>
        <template v-if="item.type === 1">
          <v-text-field
            outlined
            hide-details
            :label="item.label"
            v-model="fields[item.name]"
            :placeholder="item.placeholder"
            autocomplete="new-password"
          ></v-text-field>
        </template>
        <template v-if="item.type === 2">
          <v-textarea outlined hide-details :label="item.label" v-model="fields[item.name]" :placeholder="item.placeholder"></v-textarea>
        </template>
        <template v-if="item.type === 3">
          <v-row>
            <v-col class="py-0" cols="12">
              <label>{{ item.label }}</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="6" sm="4" md="4" lg="3" v-for="(options, index) in item.default_value.options" :key="index">
              <v-checkbox hide-details v-model="fields[item.name]" :label="options.label" :value="options.value" multiple></v-checkbox>
            </v-col>
          </v-row>
        </template>
        <template v-if="item.type === 4">
          <label>{{ item.label }}</label>
          <v-radio-group row hide-details v-model="fields[item.name]">
            <v-radio
              v-for="(options, index) in item.default_value.options"
              :key="index"
              :label="options.label"
              :value="options.value"
            ></v-radio>
          </v-radio-group>
        </template>
        <template v-if="item.type === 5">
          <template v-if="item.default_value.isAPI">
            <v-autocomplete
              :no-data-text="$t('global.no_data_text')"
              outlined
              :items="item.default_value.options"
              :label="item.label"
              v-model="fields[item.name]"
              autocomplete="new-password"
              :ref="`searchInput${item._id}`"
              :placeholder="item.placeholder"
              clearable
              hide-details
              :item-text="item.default_value.name"
              :item-value="item.default_value.name"
            ></v-autocomplete>
          </template>
          <template v-else>
            <v-autocomplete
              :no-data-text="$t('global.no_data_text')"
              outlined
              :items="item.default_value.options"
              :label="item.label"
              :multiple="item.default_value.is_multiselect"
              v-model="fields[item.name]"
              :placeholder="item.placeholder"
              clearable
              hide-details
              item-text="label"
              item-value="value"
              autocomplete="new-password"
            ></v-autocomplete>
          </template>
        </template>
        <template v-if="item.type === 6">
          <v-menu v-model="item.date_menu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                hide-details
                v-model="fields[item.name]"
                :placeholder="item.placeholder"
                clearable
                prepend-icon="mdi-calendar"
                :label="item.label"
                readonly
                v-on="on"
                @click:clear="fields[item.name] = null"
                autocomplete="new-password"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="$locale_bcp47()"
              v-model="item.date_value"
              @input=";(fields[item.name] = parseDate(item.date_value)), (item.date_menu = false)"
              color="primary darken-2"
              header-color="primary"
            ></v-date-picker>
          </v-menu>
        </template>
        <template v-if="item.type === 7">
          <v-menu
            :ref="`time_menu_${item._id}`"
            v-model="item.time_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="fields[item.name]"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                hide-details
                v-model="fields[item.name]"
                :placeholder="item.placeholder"
                clearable
                prepend-icon="mdi-timer"
                :label="item.label"
                readonly
                v-on="on"
                @click:clear="fields[item.name] = null"
                autocomplete="new-password"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="item.time_menu"
              v-model="fields[item.name]"
              format="24hr"
              full-width
              @click:minute="$refs[`time_menu_${item._id}`][0].save(fields[item.name])"
            ></v-time-picker>
          </v-menu>
        </template>
        <template v-if="item.type === 8">
          <v-switch inset :label="item.label" v-model="fields[item.name]" hide-details></v-switch>
        </template>
        <template v-if="item.type === 9">
          <v-file-input
            outlined
            :label="item.label"
            v-model="fields[item.name]"
            hide-details
            :placeholder="item.placeholder"
          ></v-file-input>
        </template>
        <template v-if="item.type === 10">
          <v-card outlined class="pa-0">
            <v-card-title class="pa-1 subtitle-1"
              >{{ item.label }}
              <v-radio-group v-model="fields[item.name]" row class="ml-2 mt-6">
                <v-radio :label="$t(item.text)" :value="item.value" v-for="(item, index) in statusList" :key="index"></v-radio>
              </v-radio-group>
            </v-card-title>
            <v-divider></v-divider>
            <v-card class="component-link" v-if="item.html">
              <v-card-text class="pa-2">
                <p v-html="item.html"></p>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
            <v-card-text class="pa-0">
              <v-tabs>
                <v-tabs-slider></v-tabs-slider>
                <v-tab>
                  <v-icon>mdi-comment-text-outline</v-icon>
                  {{ $t("checklistapi.form.comments") }}
                </v-tab>
                <v-tab>
                  <v-icon class="mdi-rotate-270">mdi-attachment</v-icon>
                  {{ $t("checklistapi.form.attachments") }}
                </v-tab>
                <v-tab-item>
                  <v-divider></v-divider>
                  <v-card flat tile>
                    <v-card-text>
                      <v-textarea hide-details outlined></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-divider></v-divider>
                  <v-card flat tile>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-file-input :label="$t('checklistapi.form.attachments')" multiple hide-details outlined dense></v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="item.type === 11">
          <v-subheader v-if="item.label" class="pa-0"
            ><b>{{ item.label }}</b></v-subheader
          >
          <v-divider></v-divider>
        </template>
        <template v-if="item.type === 12">
          <v-card class="d-flex align-content-start flex-wrap pa-0 avalia_form_grid" flat tile>
            <v-card
              min-width="80"
              v-for="(grid, index) in item.default_value.grid_data.labels"
              :key="index"
              class="pa-0 pl-1 text-left"
              outlined
              tile
            >
              <span class="subtitle-2">{{ grid.label }}</span>
            </v-card>
          </v-card>
        </template>
        <template v-if="item.type === 13">
          <v-subheader v-if="item.label" class="pa-0"
            ><b>{{ item.label }}</b></v-subheader
          >
          <VueSignaturePad
            width="100%"
            :height="`${$format.$_setSignaturePadHeight(item)}px`"
            class="signature--pad"
            :ref="`signaturePad_${item._id}`"
          />
        </template>
        <template v-if="item.type === 14">
          <v-card class="pa-1 ml-1">
            <v-card-title class="pa-1 caption font-weight-bold">
              {{ item.label }}
              <v-spacer></v-spacer>
              <v-btn icon small color="info" fab @click="clonePanelHandler(item)"><v-icon>mdi-content-copy</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-1">
              <drop @drop="addToPanel(item)" class="row">
                <v-col
                  class="pt-1 pb-1"
                  cols="12"
                  :md="
                    subField.columns
                      ? subField.columns
                      : subField.type === 10 || subField.type === 11 || subField.type === 12 || subField.type === 14
                      ? '12'
                      : '3'
                  "
                  v-for="subField in item.panel_fields"
                  :key="subField._id"
                >
                  <form-fields :fields="fields" :item="subField" :parseDate="parseDate" :edit="edit" :remove="remove"></form-fields>
                </v-col>
                <v-col cols="12" v-if="!item.panel_fields">
                  <v-alert color="primary" class="text-center" outlined dark border="left" prominent :style="{ 'min-height': `100px` }">
                    <span class="text-center">
                      {{ $t("checklistapi.form.dropFields") }}
                    </span>
                  </v-alert>
                </v-col>
              </drop>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="item.type === 15">
          <span
            class="pa-0 subtitle-2"
            :style="{
              fontSize: `${item.default_value.font_size}em !important`
            }"
            >{{ item.label }}</span
          >
        </template>
        <template v-if="item.type === 16">
          <div v-html="item.default_value.html_content"></div>
        </template>
        <template v-if="item.type === 19">
          <v-card class="d-flex flex-row" flat>
            <v-card flat outlined width="100%">
              <v-row class="mx-0">
                <v-col class="pa-0 my-auto">
                  <v-card-title class="pa-1 subtitle-1">{{ item.label }}</v-card-title>
                </v-col>
                <v-col class="pa-0 my-auto">
                  <template v-if="item.default_value.surveyOptions && item.default_value.surveyOptions.selectionType === 1">
                    <v-layout row wrap class="mx-0 ml-2">
                      <v-checkbox
                        readonly
                        hide-details
                        class="my-auto pa-0"
                        v-model="fields[item.name]"
                        :label="item.label"
                        :value="item.value"
                        v-for="(item, index) in item.default_value.options.filter((x) => x.isactive).filter((x) => x.isactive)"
                        :key="index"
                        multiple
                      ></v-checkbox>
                    </v-layout>
                  </template>
                  <template v-else>
                    <v-layout row wrap class="mx-0 ml-2">
                      <v-radio-group readonly hide-details v-model="fields[item.name]" row class="ml-2 my-auto pa-0">
                        <v-radio
                          hide-details
                          :label="item.label"
                          :value="item.value"
                          v-for="(item, index) in getActiveOptions(item.default_value)"
                          :key="index"
                        ></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </template>
                </v-col>
                <v-col class="pa-0 px-1 my-auto" v-if="item.default_value.checkboxFlags.signature">
                  <v-text-field
                    autocomplete="new-password"
                    outlined
                    hide-details
                    :label="$t('checklistapi.form.signature')"
                    readonly
                    dense
                  ></v-text-field>
                </v-col>
                <v-col class="pa-0 px-1 my-auto" v-if="item.default_value.checkboxFlags.date">
                  <v-menu :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        disabled
                        dense
                        outlined
                        hide-details
                        clearable
                        prepend-inner-icon="mdi-calendar"
                        :label="$t('checklistapi.form.date')"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="primary darken-2" header-color="primary"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-divider
                class="ma-0 pa-0"
                v-show="!item.default_value.hideComments || !item.default_value.hideAttachments || item.html"
              ></v-divider>
              <v-card class="component-link" v-if="item.html">
                <v-card-text class="pa-2">
                  <p v-html="item.html"></p>
                </v-card-text>
                <v-divider class="ma-0 pa-0"></v-divider>
              </v-card>
              <v-card-text class="pa-0" v-if="!item.default_value.hideComments || !item.default_value.hideAttachments">
                <v-tabs>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab v-if="!item.default_value.hideComments">
                    <v-icon>mdi-comment-text-outline</v-icon>
                    {{ $t("checklistapi.form.comments") }}
                  </v-tab>
                  <v-tab v-if="!item.default_value.hideAttachments">
                    <v-icon class="mdi-rotate-270">mdi-attachment</v-icon>
                    {{ $t("checklistapi.form.attachments") }}
                  </v-tab>
                  <v-tab-item v-if="!item.default_value.hideComments">
                    <v-divider class="ma-0 pa-0"></v-divider>
                    <v-card flat tile>
                      <v-card-text>
                        <v-textarea hide-details outlined></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="!item.default_value.hideAttachments">
                    <v-divider class="ma-0 pa-0"></v-divider>
                    <v-card flat tile>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-file-input :label="$t('checklistapi.form.attachments')" multiple hide-details outlined dense></v-file-input>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-card>
        </template>
        <template v-if="item.type === 20">
          <v-card outlined class="pa-0">
            <v-card-title class="pa-1 subtitle-1" style="background: #f7f7f7">
              <v-row class="mx-0">
                <v-col cols="1" class="py-0">{{ item.slNo }}</v-col>
                <v-col cols="3" class="pa-0">{{ item.label }}</v-col>
                <!-- <v-col cols="8" class="py-0">
                  <span class="mr-10">NA</span><span class="ml-10">0-3</span>
                </v-col> -->
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <template v-for="(subitem, index) in item.default_value.subitems">
                <v-row class="mx-0 py-3" :style="`background: ${index % 2 !== 0 ? '#f7f7f7' : ''}`" :key="index">
                  <v-col cols="1" class="py-0 subtitle-1 font-weight-medium">{{ `${item.slNo}.${index + 1}` }}</v-col>
                  <v-col cols="3" class="pa-0 pr-5">
                    <p class="pa-0 ma-0 subtitle-1">{{ subitem.label }}</p>
                    <!-- <v-text-field outlined hide-details dense autocomplete="new-password"></v-text-field> -->
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-layout row wrap>
                      <v-radio-group row class="mt-0 mx-1" readonly>
                        <v-radio
                          :value="item.value"
                          v-for="(item, index) in checkPointRadios"
                          :key="index"
                          :class="item.value === '-' ? 'mr-10' : 'ma-0'"
                        ></v-radio>
                      </v-radio-group>
                      <v-textarea
                        readonly
                        class="mx-1"
                        outlined
                        rows="3"
                        hide-details
                        :label="$t('checklisttemplate.comments')"
                        :placeholder="$t('checklisttemplate.comments')"
                      ></v-textarea>
                      <v-file-input disabled hide-details="" class="mx-1" prepend-icon="mdi-camera" label="File"></v-file-input>
                      <v-checkbox readonly hide-details="" class="mx-1 font-weight-bold" label="U"></v-checkbox>
                      <v-menu v-model="checkpoint.date_menu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            disabled
                            class="mx-1 mt-4"
                            dense
                            outlined
                            hide-details
                            v-model="checkpoint.date"
                            clearable
                            prepend-inner-icon="mdi-calendar"
                            :label="$t('checklisttemplate.date')"
                            readonly
                            v-on="on"
                            @click:clear="checkpoint.date = null"
                            autocomplete="new-password"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$locale_bcp47()"
                          v-model="checkpoint.date_value"
                          @input=";(checkpoint.date = parseDate(checkpoint.date_value)), (checkpoint.date_menu = false)"
                          color="primary darken-2"
                          header-color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-layout>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="item.type === 21">
          <v-layout row wrap justify-center>
            <label class="subtitle-1 font-weight-medium">{{ item.label }}</label>
            <v-radio-group readonly row class="ma-0 mx-2" hide-details>
              <v-radio :label="item.text" :value="item.value" v-for="(item, index) in checkPointYesNoRadios" :key="index"></v-radio>
            </v-radio-group>
          </v-layout>
        </template>
        <template v-if="item.type === 22"
          ><!-- Formula Type 1 -->
          <v-card outlined class="pa-0">
            <v-card-title class="pa-1 subtitle-1" style="background: #f7f7f7">
              <v-row class="mx-0">
                <v-col cols="1" class="py-0">{{ item.slNo }}</v-col>
                <v-col cols="3" class="pa-0">{{ item.label }}</v-col>
                <v-col cols="8" class="py-0"> <span class="mr-10">NA</span><span class="ml-10">0-3</span> </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <template v-for="(subitem, index) in item.default_value.subitems">
                <v-row class="mx-0 py-3" :style="`background: ${index % 2 !== 0 ? '#f7f7f7' : ''}`" :key="index">
                  <v-col cols="1" class="py-0 subtitle-1 font-weight-medium">{{ `${item.slNo}.${index + 1}` }}</v-col>
                  <v-col cols="3" class="pa-0 pr-5">
                    <p class="pa-0 ma-0 subtitle-1">{{ subitem.label }}</p>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-layout row wrap>
                      <v-radio-group row class="mt-0 mx-1" readonly>
                        <v-radio
                          :value="item.value"
                          v-for="(item, index) in checkPointRadios"
                          :key="index"
                          :class="item.value === '-' ? 'mr-10' : 'ma-0'"
                        ></v-radio>
                      </v-radio-group>
                      <v-textarea readonly class="mx-1" outlined rows="3" hide-details label="Comments" placeholder="Comments"></v-textarea>
                      <v-file-input disabled hide-details="" class="mx-1" prepend-icon="mdi-camera" label="File"></v-file-input>
                      <v-checkbox readonly hide-details="" class="mx-1 font-weight-bold" label="U"></v-checkbox>
                      <v-menu v-model="subitem.date_menu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mx-1 mt-4"
                            disabled
                            dense
                            outlined
                            hide-details
                            v-model="subitem.date"
                            clearable
                            prepend-inner-icon="mdi-calendar"
                            label="Date"
                            readonly
                            v-on="on"
                            @click:clear="subitem.date = null"
                            autocomplete="new-password"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="subitem.date_value"
                          :locale="$locale_bcp47()"
                          @input=";(subitem.date = parseDate(subitem.date_value)), (subitem.date_menu = false)"
                          color="primary darken-2"
                          header-color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-layout>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="item.type === 23"
          ><!-- Formula Type 2 -->
          <v-card outlined class="pa-0">
            <v-card-title class="pa-1 subtitle-1" style="background: #f7f7f7">
              <v-row class="mx-0">
                <v-col cols="1" class="py-0">{{ item.slNo }}</v-col>
                <v-col cols="3" class="pa-0">{{ item.label }}</v-col>
                <v-col cols="8" class="py-0">
                  <span :class="letter === 'N/A' ? 'ml-6' : 'mr-5'" v-for="(letter, index) in ['A', 'B', 'C', 'D', 'N/A']" :key="index">{{
                    letter
                  }}</span>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <template v-for="(subitem, index) in item.default_value.subitems">
                <v-row class="mx-0 py-3" :style="`background: ${index % 2 !== 0 ? '#f7f7f7' : ''}`" :key="index">
                  <v-col cols="1" class="py-0 subtitle-1 font-weight-medium">{{ `${item.slNo}.${index + 1}` }}</v-col>
                  <v-col cols="3" class="pa-0 pr-5">
                    <p class="pa-0 ma-0 subtitle-1">{{ subitem.label }}</p>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <v-layout row wrap>
                      <v-radio-group row class="mt-0 mx-1" readonly>
                        <v-radio
                          :value="item.value"
                          v-for="(item, index) in checkPointRadios"
                          :key="index"
                          :class="item.value === '2' ? 'mr-10' : 'ma-0'"
                        ></v-radio>
                      </v-radio-group>
                      <v-textarea readonly class="mx-1" outlined rows="3" hide-details label="Comments" placeholder="Comments"></v-textarea>
                      <v-file-input disabled hide-details="" class="mx-1" prepend-icon="mdi-camera" label="File"></v-file-input>
                      <v-checkbox readonly hide-details="" class="mx-1 font-weight-bold" label="U"></v-checkbox>
                      <v-menu v-model="subitem.date_menu" :close-on-content-click="false" max-width="290">
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            class="mx-1 mt-4"
                            disabled
                            dense
                            outlined
                            hide-details
                            v-model="subitem.date"
                            clearable
                            prepend-inner-icon="mdi-calendar"
                            label="Date"
                            readonly
                            v-on="on"
                            @click:clear="subitem.date = null"
                            autocomplete="new-password"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="subitem.date_value"
                          :locale="$locale_bcp47()"
                          @input=";(subitem.date = parseDate(subitem.date_value)), (subitem.date_menu = false)"
                          color="primary darken-2"
                          header-color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-layout>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </template>
        <template v-if="item.type === 24"
          ><!-- Formula Type 3 -->
          <v-card outlined class="pa-0">
            <v-card-title class="pa-1 subtitle-1" style="background: #f7f7f7">
              <v-row class="mx-0">
                <!-- <v-col cols="1" class="py-0">{{item.slNo}}</v-col> -->
                <v-col cols="6" class="pa-0">{{ item.label }}</v-col>
                <v-col cols="6" class="py-0">
                  <v-layout row wrap class="mx-0">
                    <v-col cols="5" class="pa-0"><span class="mr-8">K</span><span class="ml-8">R</span></v-col>
                    <v-col cols="3" class="pa-0"><span>U</span></v-col>
                  </v-layout>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <template v-for="(subitem, index) in item.default_value.subitems">
                <v-row class="mx-0 py-3" :style="`background: ${index % 2 !== 0 ? '#f7f7f7' : ''}`" :key="index">
                  <!-- <v-col cols="1" class="py-0 subtitle-1 font-weight-medium">{{ `${item.slNo}.${index + 1}` }}</v-col> -->
                  <v-col cols="6" class="py-0 pa-2 pr-4">
                    <v-layout row wrap class="mx-0">
                      <v-col cols="6" class="pa-0 ma-0">
                        <p class="py-0 ma-0 subtitle-1">{{ subitem.label }}</p>
                      </v-col>
                      <v-col cols="6" class="pa-0 ma-0">
                        <v-text-field autocomplete="new-password" readonly outlined hide-details dense></v-text-field>
                      </v-col>
                    </v-layout>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-layout row wrap>
                      <v-col cols="5" class="pa-0">
                        <v-radio-group row class="mt-0 mx-1" readonly>
                          <v-radio
                            :value="item.value"
                            v-for="(item, index) in checkPointRadios"
                            :key="index"
                            :class="item.value === '-' ? 'mr-10' : 'ma-0'"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="2" class="pa-0">
                        <v-checkbox readonly hide-details="" class="mt-0 font-weight-bold"></v-checkbox>
                      </v-col>
                      <v-col cols="5" class="pa-0">
                        <v-menu v-model="checkpoint.date_menu" :close-on-content-click="false" max-width="290" class="pl-2">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              disabled
                              class="mx-1"
                              dense
                              outlined
                              hide-details
                              v-model="checkpoint.date"
                              clearable
                              prepend-inner-icon="mdi-calendar"
                              :label="$t('checklisttemplate.date')"
                              readonly
                              v-on="on"
                              @click:clear="checkpoint.date = null"
                              autocomplete="new-password"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :locale="$locale_bcp47()"
                            v-model="checkpoint.date_value"
                            @input=";(checkpoint.date = parseDate(checkpoint.date_value)), (checkpoint.date_menu = false)"
                            color="primary darken-2"
                            header-color="primary"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-layout>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </template>
        <v-expand-transition>
          <v-layout justify-end>
            <v-fade-transition>
              <v-btn text x-small icon color="info" @click="edit(item)"><v-icon v-show="hover">mdi-pencil</v-icon></v-btn>
            </v-fade-transition>
            <v-fade-transition>
              <v-btn text x-small icon color="error" @click="remove(item)"><v-icon v-show="hover">mdi-window-close</v-icon></v-btn>
            </v-fade-transition>
          </v-layout>
        </v-expand-transition>
      </div>
    </v-hover>
    <v-dialog v-model="showCloneDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t("checklistapi.app.confirmation") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t("checklistapi.form.sureToCloneFields") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" id="cloneConfirm" :loading="loading" @click="confirmToClone">{{ $t("checklistapi.app.yes") }}</v-btn>
          <v-btn color="error" id="deleteClose" @click="showCloneDialog = false">{{ $t("checklistapi.app.no") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Vue from "vue"
import VueSignaturePad from "vue-signature-pad"
import { Drop } from "vue-drag-drop"
import { componentStatusList } from "@/utils/support_list"

Vue.use(VueSignaturePad)

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    /*fields: {
      type: Object,
      default: () => {}
    },*/
    addToPanel: {
      type: Function,
      default: () => {}
    },
    // parseDate: {
    //   type: Function,
    //   default: () => {}
    // },
    edit: {
      type: Function,
      default: () => {}
    },
    remove: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showCloneDialog: false,
      clonedPanel: {},
      loading: false,
      statusList: componentStatusList,
      /* for checkpoint component */
      checkPointRadios: [{ value: "-" }, { value: "0" }, { value: "1" }, { value: "2" }, { value: "3" }],
      checkPointYesNoRadios: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" }
      ],
      /* for date test */
      checkpoint: {}
    }
  },
  components: {
    Drop,
    FormFields: () => import("./Fields")
  },
  mounted() {
    this.$root.$on("hideLoadingForCloneFields", () => {
      this.loading = false
      this.showCloneDialog = false
    })
  },
  methods: {
    clonePanelHandler(panel) {
      this.showCloneDialog = true
      this.clonedPanel = panel
    },
    confirmToClone() {
      this.loading = true
      this.$root.$emit("clonePanelEvent", this.clonedPanel)
    },
    getCols(item) {
      // for component 19
      let flagObj = item.default_value.checkboxFlags
      return flagObj.signature || flagObj.date ? (flagObj.signature && flagObj.date ? 8 : 10) : 12
    },
    getCheckboxLabelWidth(options) {
      options.label = options.label || ""
      return options.label.length + 100 > 200 ? 350 : options.label.length + 100
    },
    getActiveOptions(defaulValue) {
      if (!defaulValue.options || defaulValue.options.length < 1) return []
      let resultOptions = defaulValue.options.filter((x) => x.isactive || x.isactive === undefined)
      resultOptions = resultOptions && resultOptions.length > 0 ? resultOptions : []
      return resultOptions
    }
  },
  beforeDestroy() {
    this.$root.$off("hideLoadingForCloneFields")
  }
}
</script>
<style>
.signature--pad {
border: 1px solid !important;
}</style>
